import styled from "styled-components";

export const FormButton = styled.button`
  width: 100%;
  max-width: 23.125rem;
  color: #fff;
  background-color: #004581;
  border: 1px solid #004581;
  margin: auto;

  &:hover {
    background-color: #fff;
    color: #004581;
  }
`;
